<script setup lang="ts">
const route = useRoute();
const { client } = usePrismic();
const { alternateLanguages } = storeToRefs(usePageStore());
const { locale, localeProperties } = useI18n();

const { data: document, error } = await useAsyncData(
  `bim_page-${locale.value}-${route.params.uid}`,
  async () => {
    const document = await client.getByUID(
      "bim_page",
      route.params.uid as string,
      {
        lang: localeProperties.value.language,
      },
    );
    return document;
  },
);

if (error.value) {
  console.log("HERE", error.value);
  throw createError({ statusCode: 404, message: "Page not found" });
}

definePageMeta({
  layout: "bim",
});

useHead({
  title:
    document.value?.data.meta_title ||
    (document.value?.data.title.map((t) => t.text).join(" ") as string),
  meta: [
    {
      name: "description",
      content:
        document.value?.data.meta_description ||
        (document.value?.data.description.reduce(
          (a, b) => a + b.text,
          "",
        ) as string),
    },
  ],
  htmlAttrs: {
    lang: locale.value,
  },
});

onNuxtReady(() => {
  alternateLanguages.value = document.value?.alternate_languages || [];
});
</script>
<template>
  <PageBim v-if="document" :document="document" />
</template>
